import { IIngressExceptionModel } from '../../../../../../models/index';
import { IActiveServiceEvent } from '../../../../../../store/actions/types/services/GetAllServiceEventTypes';

/**
 * Form Actions
 */
export const INGRESS_EVENT_FORM_ACTIONS = {
  ADD_EXCEPTION_CLICKED: 'ADD_EXCEPTION_CLICKED',
  ADD_ALL_EXCEPTION_CLICKED: 'ADD_ALL_EXCEPTION_CLICKED',
  DELETE_EXCEPTION_CLICKED: 'DELETE_EXCEPTION_CLICKED',
  DELETE_DUPLICATE_EXCEPTION: 'DELETE_DUPLICATE_EXCEPTION',
  EDIT_EXCEPTION_CLICKED: 'EDIT_EXCEPTION_CLICKED',
  UPDATE_EXCEPTION_CLICKED: 'UPDATE_EXCEPTION_CLICKED',
  CLEAR_EXCEPTIONS: 'CLEAR_EXCEPTIONS',
  SAVE_SEARCH_LIST_DATA: 'SAVE_SEARCH_LIST_DATA',
  SET_SEARCH_VALUE: 'SET_SEARCH_VALUE',
  SET_SEARCH_LIST_VISIBLE: 'SET_SEARCH_LIST_VISIBLE',
  ON_SEARCH_VALUE_SELECT: 'ON_SEARCH_VALUE_SELECT',
  CLEAR_SEARCH_LIST_DATA: 'CLEAR_SEARCH_LIST_DATA'
};

export interface IExceptionAction {
  type: string,
  addExceptionPayload?: { exception: IIngressExceptionModel }
  addAllExceptionPayload?: { exceptions: IIngressExceptionModel[] }
  deleteExceptionPayload?: { index: number },
  deleteDuplicateException?: { exceptionId: string }
  editExceptionPayload?: { isEditButtonClick: boolean, editIndex: number | undefined }
  updateExceptionPayload?: { exception: IIngressExceptionModel, editIndex?: number }
}

export interface IExceptionState {
  isEditExceptionClicked: boolean,
  editIndex: number | undefined,
  exceptionList: IIngressExceptionModel[],
}

export const exceptionFormInitialState: IExceptionState = {
  isEditExceptionClicked: false,
  editIndex: undefined,
  exceptionList: []
};

/**
 * Reducer function to manage exceptions state
 * @param state : IExceptionState
 * @param action : actions to perform on state
 * @returns IExceptionState
 */
export const getExceptionFormStateReducer = (state: IExceptionState, action: IExceptionAction) => {
  switch (action.type) {
    case INGRESS_EVENT_FORM_ACTIONS.ADD_EXCEPTION_CLICKED: {
      return {
        ...state,
        exceptionList: action.addExceptionPayload?.exception ? [...state.exceptionList, action.addExceptionPayload.exception] : state.exceptionList
      };
    }

    case INGRESS_EVENT_FORM_ACTIONS.ADD_ALL_EXCEPTION_CLICKED: {
      return {
        ...state,
        exceptionList: action.addAllExceptionPayload?.exceptions ? action.addAllExceptionPayload.exceptions : state.exceptionList
      };
    }

    case INGRESS_EVENT_FORM_ACTIONS.EDIT_EXCEPTION_CLICKED: {
      return {
        ...state,
        isEditExceptionClicked: action.editExceptionPayload?.isEditButtonClick !== undefined ? action.editExceptionPayload?.isEditButtonClick : false,
        editIndex: action.editExceptionPayload?.editIndex !== undefined ? action.editExceptionPayload?.editIndex : undefined
      };
    }

    case INGRESS_EVENT_FORM_ACTIONS.UPDATE_EXCEPTION_CLICKED: {
      const index = action.updateExceptionPayload?.editIndex;
      const newExceptionList = [...state.exceptionList];
      newExceptionList.splice(index !== undefined ? index : 0, 1, action.updateExceptionPayload?.exception !== undefined ? action.updateExceptionPayload?.exception : {
        exceptionId: '',
        errorCode: '',
        action: []
      });

      return {
        ...state,
        exceptionList: newExceptionList,
        isEditExceptionClicked: false,
        editIndex: undefined
      };
    }

    case INGRESS_EVENT_FORM_ACTIONS.DELETE_EXCEPTION_CLICKED: {
      return {
        ...state,
        exceptionList: [...state.exceptionList.filter((_item, itemIndex) => action.deleteExceptionPayload?.index !== itemIndex)]
      };
    }

    case INGRESS_EVENT_FORM_ACTIONS.DELETE_DUPLICATE_EXCEPTION: {
      return {
        ...state,
        exceptionList: [...state.exceptionList].filter((exception) => exception.exceptionId !== action.deleteDuplicateException?.exceptionId)
      };
    }

    case INGRESS_EVENT_FORM_ACTIONS.CLEAR_EXCEPTIONS: {
      return {
        ...state,
        exceptionList: []
      };
    }
    default:
      return state;
  }
};

interface ISearchListAction {
  type: string,
  addSearchListPayload?: { searchListData: IActiveServiceEvent[] },
  searchListVisiblePayload?: { searchListVisible: boolean },
  searchValuePayload?: { searchValue: string }

}

export interface ISearchListState {
  searchListVisible: boolean,
  searchValue: string,
  searchListData: IActiveServiceEvent[]
}

export const searchListInitialState: ISearchListState = {
  searchListVisible: false,
  searchValue: '',
  searchListData: new Array<IActiveServiceEvent>()
};

/**
 * Reducer function to manage search List state
 * @param state : ISearchListState
 * @param action : actions to perform on state
 * @returns ISearchListState
 */
export const getIngressEventSearchListStateReducer = (state: ISearchListState, action: ISearchListAction): ISearchListState => {
  switch (action.type) {
    case INGRESS_EVENT_FORM_ACTIONS.SET_SEARCH_VALUE: {
      return {
        ...state,
        searchValue: action.searchValuePayload?.searchValue ? action.searchValuePayload?.searchValue : '',
      };
    }

    case INGRESS_EVENT_FORM_ACTIONS.SET_SEARCH_LIST_VISIBLE: {
      return {
        ...state,
        searchListVisible: action.searchListVisiblePayload?.searchListVisible !== undefined ? action.searchListVisiblePayload?.searchListVisible : false
      };
    }

    case INGRESS_EVENT_FORM_ACTIONS.SAVE_SEARCH_LIST_DATA: {
      return {
        ...state,
        searchListData: action.addSearchListPayload?.searchListData ? action.addSearchListPayload?.searchListData : []
      };
    }

    case INGRESS_EVENT_FORM_ACTIONS.ON_SEARCH_VALUE_SELECT: {
      return {
        ...state,
        searchListData: action.addSearchListPayload?.searchListData ? action.addSearchListPayload?.searchListData : [],
        searchValue: action.searchValuePayload?.searchValue ? action.searchValuePayload?.searchValue : '',
        searchListVisible: action.searchListVisiblePayload?.searchListVisible !== undefined ? action.searchListVisiblePayload?.searchListVisible : false
      };
    }

    case INGRESS_EVENT_FORM_ACTIONS.CLEAR_SEARCH_LIST_DATA: {
      return {
        ...state,
        searchListData: [],
        searchValue: '',
        searchListVisible: false
      };
    }
    default:
      return state;
  }
};
